<template>
  <div style="min-height: 750px;" v-if="d_usrShpBundWdm && !d_frontendLoading">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['add_dataset_list'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
        <template v-if="d_bundleListLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <b-row style="margin-bottom: 10px;">
            <b-col sm="12" lg="6"> </b-col>
            <b-col sm="12" lg="6" style="text-align: right;">
              <b-button size="sm" v-if="d_shopList.length > 0" @click="f_newBundle()" variant="primary">
                {{ StoreLangTranslation.data['new_dataset'][StoreLang] }}
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" lg="12">
              <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
            </b-col>
          </b-row>
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="2">
              <strong> {{ d_usrShpBundWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
            </b-col>
            <b-col sm="12" lg="9">
              <strong> {{ d_usrShpBundWdm['0']['parameters']['1']['name']['translation'][StoreLang] }} </strong>
            </b-col>
            <b-col sm="12" lg="1"> </b-col>
          </b-row>
          <b-row v-for="(wdmr_item, wdmr_item_ind) in d_usrCreatedBundleList" v-if="f_searchUserShopBundle(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'">
            <b-col sm="12" lg="2">
              
              <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
              </template>
            
            </b-col>
            <b-col sm="12" lg="9">
              
              <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['lang'] && wdmr_item.data['0']['1']['lang'][StoreLang]">
                <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['lang'][StoreLang] }}</span>
              </template>
              <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['val']">
                <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['val'] }}</span>
              </template>
            
            </b-col>
            <b-col sm="12" lg="1">
              <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                <template slot="button-content">
                  {{ StoreLangTranslation.data['action'][StoreLang] }}
                </template>
                <b-dropdown-item @click="f_showBundle(wdmr_item.client_id, wdmr_item.parent_c.id)"><i class="fa fa-eye"></i> {{ StoreLangTranslation.data['show'][StoreLang] }} </b-dropdown-item>
                <b-dropdown-item v-if="wdmr_item['data']['0']['0'] && wdmr_item['data']['0']['0']['val']['value'] && wdmr_item['data']['0']['0']['val']['value'] !== '1'" @click="f_editBundle(wdmr_item.client_id, wdmr_item.parent_c.id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['edit'][StoreLang] }} </b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-row>
        </template>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>


    <b-modal v-if="d_showBundleModal" id="d_showBundleModal" v-model="d_showBundleModal" scrollable hide-footer :title="StoreLangTranslation.data['show'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template v-if="d_modalLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template v-else>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_productData.pro_name[StoreLang] }}
          </b-col>
        </b-row>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_productData.pro_info[StoreLang] }}
          </b-col>
        </b-row>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            {{ d_productData.wanalyzer_project_id[StoreLang] }}
          </b-col>
        </b-row>
        <hr>
        <template v-if="d_datasetViewLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <w-table2 style="transition: 2s; transform: none;" v-if="d_datasetWTable" :key="'dataset_view'" :p_tableDetails="d_datasetWTable"></w-table2>
        </template>
        <b-row style="margin: 3px; padding-top: 10px;">
          <b-col sm="12" lg="12">
            <b-button v-if="d_bundleData['status'] !== '1'" @click="f_changeToModal('edit')" variant="warning">{{ StoreLangTranslation.data['edit'][StoreLang] }}</b-button>
            <b-button @click="d_showBundleModal = false" variant="danger" style="float: right;">{{ StoreLangTranslation.data['cancel'][StoreLang] }}</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <b-modal v-if="d_editBundleModal" id="d_editBundleModal" v-model="d_editBundleModal" scrollable hide-footer :title="StoreLangTranslation.data['edit'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <template v-if="d_modalLoading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </template>
      <template v-else>

        <template v-if="!d_shopClientId">
          <b-row style="margin: 3px;">
            <b-col sm="12" lg="4">
              <strong>{{ StoreLangTranslation.data['shop'][StoreLang] }}</strong>
            </b-col>
            <b-col sm="12" lg="8">
              <select class="form-control" v-model="d_shopClientId">
                <option v-for="(op, op_index) in d_shopList" :value="op.client_id">
                  {{ op.name[StoreLang] }}
                </option>
              </select>
            </b-col>
          </b-row>
          <hr>
        </template>


        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-textarea rows="1" class="form-control" v-model="d_productData.pro_name[lang.label]"></b-form-textarea>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleProductWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-textarea rows="3" class="form-control" v-model="d_productData.pro_info[lang.label]"></b-form-textarea>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>
              {{ StoreLangTranslation.data['excel_file'][StoreLang] }}
            </strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-file
              v-model="d_excelFile"
              accept=".xlsx, .xls"
              ref="excelFileInput"
              @change="f_handleFileUpload"
              :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
              :placeholder="StoreLangTranslation.data['select_excel_file'][StoreLang]"
            ></b-form-file>
          </b-col>
        </b-row>
        <b-row style="margin: 3px; padding-top: 10px;">
          <b-col sm="12" lg="12">
            <b-button v-if="d_bundleClientId" @click="f_changeToModal('show')" variant="warning">{{ StoreLangTranslation.data['show'][StoreLang] }}</b-button>
            <b-button @click="d_editBundleModal = false" variant="danger" style="float: right;">{{ StoreLangTranslation.data['cancel'][StoreLang] }}</b-button>
            <b-button @click="f_saveBundle()" :disabled="d_bundleClientId || d_excelFileBase64 ? false : true" variant="success" style="float: right; margin-right: 5px">{{ StoreLangTranslation.data['save'][StoreLang] }}</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import { mapGetters } from 'vuex';
import {
  default as WTable2
} from '@/components/widgets/WTable2';
export default {
  name: 'user_shop_bundle_list',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',

  }),
  components: {
    WTable2,
  },
  props: {},
  data () {
    return {
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_usrCreatedBundleList: [],
      d_bundleListLoading: false,
      d_shopList: [],
      d_usrShpBundWdm: '',
      d_userShopBundleProductWdm: '',
      d_bundleData: {
        'status': '',
        'bundle_name': {},
      },
      d_productData: {
        'status': '',
        'pro_name': {},
        'pro_info': {},
        'wanalyzer_project_id': {},
      },
      ClsUser: ClsUser,
      d_bundleClientId: '',
      d_shopClientId: '',
      d_bundleWdmr: '',
      d_editBundleModal: false,
      d_showBundleModal: false,
      d_modalLoading: false,
      d_saveLoading: false,
      d_datasetViewLoading: false,
      d_excelFile: null,
      d_excelFileName: '',
      d_excelFileBase64: '',
      d_datasetWTable: '',
      d_frontendData: {
        'application_name': {},
        'are_shop_pages_active': '',
        'login_background_color': '',
        'login_buttons_background_color': '',
        'login_card_in_background_color': '',
        'login_card_in_shadow_color': '',
        'login_card_out_background_color': '',
        'login_card_out_shadow_color': '',
        'login_function': '',
        'register_function': '',
        'login_function_external': '',
        'login_inputs_border_color': '',
        'login_loading_background_color': '',
        'login_slogan_text': {},
        'mail_api_send_mail_uri': '',
        'mail_api_token_password': '',
        'mail_api_token_uri': '',
        'mail_api_token_username': '',
        'menu_background_color': '',
        'menu_border_bottom_color': '',
        'menu_box_shadow_color': '',
        'menu_child_item_background_color': '',
        'menu_child_item_border_bottom_color': '',
        'menu_child_item_text_color': '',
        'navbar_application_name_color': '',
        'menu_parent_item_background_color': '',
        'menu_parent_item_border_bottom_color': '',
        'menu_parent_item_text_color': '',
        'menu_top_caption': {},
        'menu_type': '',
        'meta': '',
        'meta_value': '',
        'navbar_application_name_shadow_color': '',
        'navbar_background_color': '',
        'password_reset_mail_approve_frontend_uri_and_route': {},
        'password_reset_mail_approve_link_text': {},
        'password_reset_mail_approve_subject': {},
        'privacy_policy_link': {},
        'register_mail_approve_frontend_uri_and_route': {},
        'register_mail_approve_link_text': {},
        'register_mail_approve_mail_from': '',
        'register_mail_approve_mail_from_password': '',
        'register_mail_approve_subject': {},
        'mail_privacy_notice_text': {},
        'mail_smtp_address': '',
        'mail_smtp_username': '',
        'mail_smtp_password': '',
        'status': '',
        'terms_of_service_link': {},
        'wanalyzer_api_password': '',
        'wanalyzer_api_url': '',
        'wanalyzer_api_username': '',
        'wanalyzer_frontend_url': '',
        'wmanager_uri': '',
        'worganization_api_password': '',
        'worganization_api_url': '',
        'worganization_api_username': '',
        'worganization_frontend_url': '',
        'worganization_organizasyon_id_values': '',
        'worganization_token': '',
        'waccount_external_key': '',
        'waccount_url': '',
        'waccount_username': '',
        'waccount_password': '',
        'waccount_system_product_id': '',
        'worganization_user_id': '',
        'application_frontend_uri': '',
        'application_backend_uri': '',
        'support_details_subject': {},
        'support_mail_from': '',
        'support_mail_from_password': '',
        'support_details_link_text': {},
        'support_details_frontend_uri_and_route': {},
        'page_area_text_color': {},
        'footer_text_color': {},
        'footer_background_color': {},
        'navbar_text_color': {},
        'facebook_link': {},
        'twitter_link': {},
        'instagram_link': {},
        'linkedin_link': {},
        'login_background_image': {},
        'footer_date': '',
        'navbar_flowing_text': {},
        'footer_date': '',
        'footer_text_padding': '',
        'footer_text_size': '',
        'footer_text_weight': '',
        'general_font_select': '',
        'general_font_size': '',
        'general_font_style': '',
        'general_font_weight': '',
        'general_text_color': '',
        'language_options': [],
        'market_visiblity_type': '',
        'navbar_font_size': '',
        'navbar_text_weight': '',
        'page_favicon': '',
        'default_language': '',
        'language_change_button_visibility': '',
        'google_analytics_id': '',
        'login_button_name': {},
        'language_change_button_type': '',
        'domain': '',
        'package_groups_to_show_in_shop': {},
        'shop_view': '',
        'users_can_upload_dataset': '',
        'wanalyzer_credit_usage': '',
      },
      d_frontendLoading: true,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_usrShpBundWdm = resp_wdm_data; });
    ClsWdm.getLayerWdm('usr_shp_bund_pro').then(resp_wdm_data => { this.d_userShopBundleProductWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.f_getFrontendSettings();

    // console.log('this.d_frontendData.users_can_upload_dataset : ',this.d_frontendData.users_can_upload_dataset)
    // console.log('this.d_frontendData.are_shop_pages_active : ',this.d_frontendData.are_shop_pages_active)
    // if (this.d_user && this.d_user.username && this.d_frontendData.are_shop_pages_active === '1' && this.d_frontendData.users_can_upload_dataset === '1') {
    //   this.f_userCreatedBundleList();
    //   this.f_langEligibleParameterProcess();
    // } else {
    //   this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    // }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
  },
  methods: {
    f_getFrontendSettings: function () {
      let query = '';
      let data = {};
      this.d_frontendLoading = true;
      ServiceFunctions.frontend_get(query, data)
        .then(resp => {
          this.d_frontendLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_frontendData = resp.data.frontend;
            this.$store.commit('MutationFrontendSettings', { 'status': 1, 'data': this.d_frontendData });
            if (this.d_user && this.d_user.username && this.d_frontendData.are_shop_pages_active === '1' && this.d_frontendData.users_can_upload_dataset === '1') {
              this.f_userCreatedBundleList();
              this.f_langEligibleParameterProcess();
            } else {
              this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_changeToModal: function (new_modal) {
      if (new_modal == 'show') {
        this.d_editBundleModal = false;
        this.d_showBundleModal = true;
        if (this.d_productData['wanalyzer_project_id'] && this.d_productData['wanalyzer_project_id'][this.StoreLang] && !this.d_datasetWTable) {
          this.f_wanalyzerProjectDatasetGet();
        }
      } else if (new_modal == 'edit') {
        this.d_showBundleModal = false;
        this.d_editBundleModal = true;
      }
    },
    f_wanalyzerProjectDatasetGet: function () {
      this.d_datasetViewLoading = true;
      let query = 'project_id=' + this.d_productData['wanalyzer_project_id'][this.StoreLang];


      // hangi tipte yetki ataması yapılacaksa kullanıcıya o eklenecek
      query += '&auth_client_id=' + this.d_user + "_" + this.d_productData['wanalyzer_project_id'][this.StoreLang] + "_dataset_filter";


      let data = {
        'pagination': '',
        'filter_rule': {},
        'wai_columns': 'no'
      };
      this.d_datasetWTable = '';
      ServiceFunctions.wanalyzer_project_dataset_get(query, data)
        .then(resp => {
          this.d_datasetViewLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_datasetWTable = resp.data.wtable;
          } else {
            let txt = 'status_code = ' + resp.data.status_code + '\n';
            txt += 'status_message = ' + resp.data.status_message;
            alert(txt);
          }
        });
    },
    // f_checkRequiredFields: function () {
    //   let res = true;
    //   for (let lang_index in this.StoreLangList.data) {
    //     console.log(this.d_productData.pro_name)
    //     console.log(this.StoreLangList.data[lang_index]['translation'][this.StoreLang])
    //     if (this.d_productData.pro_name[this.StoreLangList.data[lang_index]['translation'][this.StoreLang]] === '') {
    //       res = false;
    //       break;
    //     }
    //     if (!this.d_bundleClientId && !this.d_excelFileBase64) {
    //       res = false;
    //       break;
    //     }
    //   }
    //   return res;
    // },
    f_saveBundle: function () {
      console.log("save...");
      let res = true;
      for (let lang_index in this.StoreLangList.data) {
        if (this.d_productData.pro_name[this.StoreLangList.data[lang_index]['translation'][this.StoreLang]] === '') {
          alert("boş yerler var");
          res = false;
          break;
        }
      }
      if (res) {
        this.d_saveLoading = true;
        let query = 'user_client_id=' + this.d_user.username;
        query += '&user_shop_client_id=' + this.d_shopClientId;
        if (this.d_bundleClientId) {
          query += '&user_shop_bundle_client_id=' + this.d_bundleClientId;
        }
        let data = {
          'bundle_data': this.d_bundleData,
          'product_data': this.d_productData,
        };
        if (this.d_excelFileBase64) {
          data['excel_file'] = this.d_excelFileBase64;
        }
        ServiceFunctions.user_created_bundle_record(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              console.log('basariliiii')
              // this.d_bundleData = resp.data['bundle_data'];
              // this.d_productData = resp.data['product_data'];
              // // this.f_langEligibleParameterProcess();
              // this.f_userCreatedBundleList();
              // // this.$forceUpdate();
              // this.f_changeToModal('show');
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });



      }
    },
    f_handleFileUpload: function (event) {
      const file = event.target.files[0];
      if (file) {
        if (file.name.endsWith('.xls') || file.name.endsWith('.xlsx')) {
          const max_size_bytes = 50 * 1024 * 1024;
          if (file.size > max_size_bytes) {
            alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang] + ' (max 50mb)');
            this.d_excelFile = null;
            this.d_excelFileBase64 = '';
            this.d_excelFileName = '';
            this.$refs.excelFileInput.reset();
          } else {
            this.d_excelFileName = file.name;

            var vm = this;
            var reader = new FileReader();
            reader.addEventListener('load', function () {
              vm.d_excelFileBase64 = reader.result;
              vm.$forceUpdate();
            }, false);
            reader.readAsDataURL(file);
          }

        } else {
          this.d_excelFile = null;
          this.d_excelFileBase64 = '';
          this.d_excelFileName = '';
          this.$refs.excelFileInput.reset();
          this.$bvToast.toast(this.StoreLangTranslation.data['upload_only_excel_file'][this.StoreLang], {
            title: this.StoreLangTranslation.data['invalid_file_type'][this.StoreLang],
            variant: 'danger',
            solid: true,
          });
        }

      } else {
        this.d_excelFileName = '';
      }
    },
    f_newBundle: function () {
      this.d_editBundleModal = true;
      this.d_modalLoading = true;
      this.f_prepareNewBundle()
        .then(() => {
          this.d_modalLoading = false;
        });
    },
    f_prepareNewBundle: function () {
      return new Promise((resolve) => {
        this.d_bundleClientId = '';
        if (this.d_shopList.length > 1) {
          this.d_shopClientId = '';
        } else {
          this.d_shopClientId = this.d_shopList[0]['client_id'];
        }
        this.d_bundleData = {
          'status': '',
          'bundle_name': {},
        };
        this.d_productData = {
          'status': '',
          'pro_name': {},
          'pro_info': {},
          'wanalyzer_project_id': {},
        };
        this.f_langEligibleParameterProcess();
        resolve();
      });
    },
    f_showBundle: function (user_shop_bundle_client_id, user_shop_client_id) {
      this.d_bundleClientId = user_shop_bundle_client_id;
      this.d_shopClientId = user_shop_client_id;
      this.d_showBundleModal = true;
      this.d_modalLoading = true;

      let query = 'user_shop_bundle_client_id=' + this.d_bundleClientId;
      query += '&user_shop_client_id=' + this.d_shopClientId;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_created_bundle_get(query, data)
        .then(resp => {
          this.d_modalLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_bundleData = resp.data['bundle_data'];
            this.d_productData = resp.data['product_data'];
            // this.f_langEligibleParameterProcess();
            if (this.d_productData['wanalyzer_project_id'] && this.d_productData['wanalyzer_project_id'][this.StoreLang]) {
              this.f_wanalyzerProjectDatasetGet();
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['pro_name', 'wanalyzer_project_id'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          if (!this.d_productData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
            this.d_productData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
          }
        }
      }
    },
    f_editBundle: function (user_shop_bundle_client_id, user_shop_client_id) {
      this.d_bundleClientId = user_shop_bundle_client_id;
      this.d_shopClientId = user_shop_client_id;
      this.d_editBundleModal = true;
      this.d_modalLoading = true;

      let query = 'user_shop_bundle_client_id=' + this.d_bundleClientId;
      query += '&user_shop_client_id=' + this.d_shopClientId;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_created_bundle_get(query, data)
        .then(resp => {
          this.d_modalLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_bundleData = resp.data['bundle_data'];
            this.d_productData = resp.data['product_data'];
            this.f_langEligibleParameterProcess();
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_searchUserShopBundle: function (usr_shp_bund) {
      let res = false;
      if (this.d_searchText) {
        for (let i in this.StoreLangList.data) {
          if (usr_shp_bund['data']['0']['1']['lang'][this.StoreLangList.data[i]['translation'][this.StoreLang]].toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
            res = true;
            break;
          }
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userCreatedBundleList: function () {
      this.d_bundleListLoading = true;
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_created_bundle_list(query, data)
        .then(resp => {
          this.d_bundleListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_usrCreatedBundleList = resp.data.list;
              this.d_shopList = resp.data.shop_list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
    d_showBundleModal: function () {
      if (!this.d_editBundleModal && !this.d_showBundleModal && this.d_datasetWTable) {
        this.d_datasetWTable = '';
      }
    },

    d_editBundleModal: function () {
      if (!this.d_editBundleModal && !this.d_showBundleModal && this.d_datasetWTable) {
        this.d_datasetWTable = '';
      }
    },
  }
};

</script>

